import React from "react";
import "../assets/Card.scss";

export default function Card({ headerText, children }) {
  return (
    <div className="card">
      <div className="card__header">
        <h2 className="card__title">{headerText}</h2>
      </div>
      <div className="card__content">{children}</div>
    </div>
  );
}
